export const RESET_STATE = 'RESET_STATE';
export const SET_VIEWER = 'SET_VIEWER';
export const SET_TRANSCRIPT = 'SET_TRANSCRIPT';
export const ADD_MESSAGE = 'ADD_MESSAGE';
export const TOGGLE_LOADER = 'TOGGLE_LOADER';
export const ABORT_ALL_LOADERS = 'ABORT_ALL_LOADERS';
export const SET_VIEWER_LOADING = 'SET_VIEWER_LOADING';

export const ADD_HISTORY_ENTRY = 'ADD_HISTORY_ENTRY';
export const INCREASE_HISTORY_POINTER = 'INCREASE_HISTORY_POINTER';
export const DECREASE_HISTORY_POINTER = 'DECREASE_HISTORY_POINTER';
export const SET_HISTORY_POINTER = 'SET_HISTORY_POINTER';
export const SET_CURRENT_JSONBPMN = 'SET_CURRENT_JSONBPMN';

export const SET_CHECKERS = 'SET_CHECKERS';
export const TOGGLE_CHECKER_SELECTION = 'TOGGLE_CHECKER_SELECTION';